var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNfcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.733,
    height: 19.494,
    viewBox: "0 0 48.733 19.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    width: 48.733,
    height: 19.494,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M18.553,4.075a6.657,6.657,0,0,1,0,6.289.974.974,0,0,0,1.712.931,8.614,8.614,0,0,0,0-8.15A.974.974,0,0,0,18.553,4.075Z",
    transform: "translate(17.693 2.529)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M22.91,1.537a17.417,17.417,0,0,1,.02,16.384A.978.978,0,1,0,24.57,18.98a19.369,19.369,0,0,0,0-18.466A.976.976,0,1,0,22.91,1.537Z",
    transform: "translate(21.82 0.001)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M20.7,2.765a11.929,11.929,0,0,1,0,11.432.974.974,0,0,0,1.706.941,13.889,13.889,0,0,0,0-13.316.975.975,0,0,0-1.706.943",
    transform: "translate(19.754 1.265)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M7.791,1.972v9.967L1.819,1.489A.974.974,0,0,0,0,1.972V15.605a.974.974,0,0,0,1.949,0V5.64l5.972,10.45a.973.973,0,0,0,1.817-.484V1.972a.973.973,0,0,0-1.947,0",
    transform: "translate(0 0.958)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M13.778,1H7.935a.974.974,0,0,0-.974.974V15.6a.973.973,0,0,0,1.947,0v-4.87h2.923a.973.973,0,0,0,0-1.947H8.908V2.944h4.87a.973.973,0,0,0,0-1.947",
    transform: "translate(6.686 0.958)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M15.831,2.945a1.95,1.95,0,0,1,1.947,1.947.974.974,0,0,0,1.949,0,3.9,3.9,0,0,0-7.791,0v7.791a3.9,3.9,0,1,0,7.791,0,.974.974,0,0,0-1.949,0,1.947,1.947,0,1,1-3.894,0V4.892a1.95,1.95,0,0,1,1.947-1.947",
    transform: "translate(11.464 0.959)",
    fill: "#1d1d1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfcIcon);
export default __webpack_public_path__ + "static/media/nfc-icon.1c8c8286a8b4c1b9a977961865506f4e.svg";
export { ForwardRef as ReactComponent };